import {config} from "./config";
import {request} from "./request";

function updateRebateLevels(data, cb, fail_cb) {
    request.post.call(this, config.apiList.rebateLevels, data, null, cb, fail_cb)
}

function getRebateLevels(data, cb, fail_cb) {
    request.get.call(this, config.apiList.rebateLevels, data, cb, fail_cb)
}



var rebateLevelApi = {
    updateRebateLevels: updateRebateLevels,
    getRebateLevels: getRebateLevels,
}

export {rebateLevelApi}